module.exports = __webpack_public_path__ + "static/media/BackgroundSound.a589e893.mp3";